import { Component, AfterContentChecked, Input, AfterViewInit, AfterContentInit, Output, EventEmitter, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { EditorElementComponent } from '../editor-element.component';
import { AnagraficaService } from '../../../../services/anagrafica.service';
import { FormsTemplateService } from '../../../../services/forms-template.service';
import { M } from '@angular/cdk/keycodes';
import { truncate } from 'fs';
import { DxSelectBoxComponent } from 'devextreme-angular';

@Component({
  selector: 'app-input-select-el',
  templateUrl: './input-select-el.component.html',
  styleUrls: ['./input-select-el.component.css'],

})
export class InputSelectElComponent {
  @ViewChild('inputSelect', { static: false }) inputSelect: ElementRef<HTMLInputElement>;
  @ViewChild('dxSelectBox', { static: false }) dxSelectBox: DxSelectBoxComponent;
  //https://stackblitz.com/edit/angular-dynamic-form-builder?file=app%2Fdynamic-form-builder%2Fdynamic-form-builder.component.ts

  @Input() fileDataInput: any
  @Input() dataSelect: any;
  @Input() dataInput: any;
  @Input() formGroup;
  @Input() isDX: boolean = true;
  @Input() tabIndex;

  @Input() ngClass: string;

  @Output() selectedEvent: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() selectedFocused: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() selectedFocusOut: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() selectedEventInitialized: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno

  lista
  optionData: any = [];
  valueExpr;
  searchEnable: boolean = true;
  displayExpr;
  selectedObject: any;
  showDropButton: boolean = true
  showClearButton: boolean = false
  queryString: string = '';
  filterOdata: string = '';
  checkQueryStringError: boolean = false;
  isMultiple: boolean = false
  dragEnabled: boolean = false
  dropEnabled: boolean = false
  searchText: string = '';
  filteredOptions: any = [];
  constructor(
    private anagraficaService: AnagraficaService,
    private formTemplateService: FormsTemplateService,
    private cdRef: ChangeDetectorRef
  ) {
    setTimeout(() => {
      this.getDataSource = this.getDataSource.bind(this)
    });

    this.focusElement = this.focusElement.bind(this)
  }
  
  ngOnInit() {

    this.lista = this.fileDataInput.lista;
    //console.log(this.lista)
    this.fileDataInput.multiple = false;
    this.valueExpr = this.lista.valueExpr;
    this.displayExpr = this.lista.displayExpr;
    this.searchEnable = (this.lista.searchEnable != undefined) ? this.lista.searchEnable : true;
    const isDefaultOption = this.lista.isDefaultOption !== undefined ? this.lista.isDefaultOption : true
    if (isDefaultOption === true) {
      this.optionData.push({
        [this.valueExpr]: null,
        [this.displayExpr]: this.lista.defaultOptionTxt !== undefined ? this.lista.defaultOptionTxt : 'Seleziona..'
      })
    }

    if (typeof this.lista.showDropDownButton != 'undefined') {
      this.showDropButton = this.lista.showDropDownButton
    }
    if (typeof this.lista.showClearButton != 'undefined') {
      this.showClearButton = this.lista.showClearButton
    }
    if (this.lista.dropEnabled == true) {
      this.dropEnabled = true;
      //this.selectedObject = [];
      //this.selectedObject.push(this.dataSelect) 
    }
    if (this.lista.dragEnabled == true) {
      this.dragEnabled = true;
      this.selectedObject = [];
      this.selectedObject.push(this.dataSelect)
    }

    if (typeof this.lista.isMultiple != 'undefined') {
      this.isMultiple = true;
      this.selectedObject = [];
      this.selectedObject.push(this.dataSelect)
    }



    setTimeout(() => {
      this.getDataSource(this.lista).then(() => {
        if (this.lista.selectFirstElement && this.lista.selectFirstElement === true) {
          if (!this.dataSelect || this.dataSelect === null) {
            this.dataSelect = this.optionData[0][this.valueExpr]
          }
        }
        this.cdRef.detectChanges()

      });
    });
  }
  // template list box
  getDisplayValue = (data: any): string => {
    let fieldD=this.fileDataInput.lista.displayExpr;    
    if(this.fileDataInput.lista.listadisplayExpr) fieldD=this.fileDataInput.lista.listadisplayExpr
    const propq =fieldD;// this.fileDataInput.lista.listadisplayExpr;
    //return data[propq];
    if(data && data[propq]) return data[propq]
    return (data && data[propq]) ? data[propq] : data[this.fileDataInput.lista.displayExpr];
  };

  ngAfterViewInit() {


    //this.inputSelect

    if (typeof this.inputSelect != 'undefined') {
      // this.onInitializzedSelect(this.inputSelect)
    }


  }

  plusClick(ev) {
    console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeee ", ev)
    ev.instance.unselectAll()
    this.dataSelect = null

  }


  async getDataSource(data?) {

    if (typeof data == 'undefined') {
      data = this.lista
    }
    this.optionData = [];
    this.queryString = typeof data.queryString != 'undefined' ? data.queryString : ''

    const isDefaultOption = this.lista.isDefaultOption !== undefined ? this.lista.isDefaultOption : true
    if (isDefaultOption === true) {
      this.optionData.push({
        [this.valueExpr]: null,
        [this.displayExpr]: this.lista.defaultOptionTxt !== undefined ? this.lista.defaultOptionTxt : 'Seleziona..'
      })
    }

    if (data.static) {
      let dataformService
      if (data.Async === true)
        dataformService = await this.formTemplateService.getDatiAsync(data.dataSource)
      else
        dataformService = this.formTemplateService.getDati(data.dataSource)

      if (typeof dataformService != 'undefined') {
        this.optionData = this.optionData.concat(dataformService)
      } else {
        if (data.items) {
          this.optionData = this.optionData.concat(data.items)
        } else this.optionData = dataformService
      }

      return
    }

    let dataS;

    this.buildAndTestQueryString()


    let theQueryStingOdata = '';
    const options = {};


    /*
    if(typeof this.searchText == 'string' && this.searchText.length > 0 && options['$skip'] != 0)
      options['$skip'] = 0;
    */

    if (this.filterOdata != '') {
      options['$filter'] = this.filterOdata;

    }



    let firstCaratter = this.queryString && this.queryString.startsWith('?') ? '&' : '?';

    for (let x in options) {

      if (x == '$filter')
        theQueryStingOdata += `${x}=${options[x]}`
      else
        theQueryStingOdata += `${x}=${options[x]}&`
    }

    theQueryStingOdata = firstCaratter + theQueryStingOdata;

    let wingap = true
    if (this.lista.wingap !== undefined) {
      wingap = this.lista.wingap;
      theQueryStingOdata = ''
    }
    if (!this.checkQueryStringError) {
      dataS = await this.anagraficaService.getElenco(data.dataSource, '', this.queryString, theQueryStingOdata, wingap)

      if (dataS['items']) {
        dataS = dataS['items']
      } else if (dataS['data']) {
        dataS = dataS['data']
      } else {
        dataS = dataS
      }



      if (dataS) {
        this.optionData = dataS
      }

      if (this.isMultiple) {
        this.filteredOptions = dataS
      }
    }
  }




  buildAndTestQueryString() {


    if (this.queryString != '') {

      let queryString = this.queryString;

      // crea un'espressione regolare per cercare "$filter=(...)"
      let regexFilter = /\$filter=\([^]*\)*/;

      // Esegui la ricerca nella stringa
      let matchFilter = queryString.match(regexFilter);

      // Verifica se c'è una corrispondenza
      if (matchFilter) {

        let parteSenzaFilter = matchFilter[0].replace(/\$filter=/, '');
        //rimuovere solo la parte ?$filter= 
        console.log("Trovato:", parteSenzaFilter);

        if (parteSenzaFilter.includes('$')) {
          for (let x in this.dataInput) {
            if (queryString.includes(x)) {
              let regex = new RegExp('\\$' + x + '\\b', 'g');
              parteSenzaFilter = parteSenzaFilter.replace(regex, this.dataInput[x]);
              //queryString = queryString.replace('$' + x, this.dataInput[x]);

            }
          }

        }

        this.filterOdata = parteSenzaFilter;

        queryString = queryString.replace(regexFilter, '');

        //Pezzottissimo
        if (queryString == '?)') {
          queryString = ''
        }

        //Altro pezzottissimo in attensa di idee, magari mi metto a sistemare più sù nel match 

        if (queryString.endsWith('?')) {
          queryString = queryString.replace('?', '')
        }


        //............
        this.queryString = queryString;
      }


      if (this.queryString.includes('$')) {

        for (let x in this.dataInput) {
          if (queryString.includes(x)) {
            let regex = new RegExp('\\$' + x + '\\b', 'g');
            if (typeof this.dataInput[x] == 'undefined') {
              this.checkQueryStringError = true;
              return
            }

            if (!this.dataInput[x]) {
              this.checkQueryStringError = true;
              return
            }

            queryString = queryString.replace(regex, this.dataInput[x]);


          }
        }
        this.checkQueryStringError = false;
        this.queryString = queryString
      }
    }
  }

  selectChange(ev, selectChange) {
    console.log('event-->', ev)
    console.log('selectChange-->', selectChange)
    let index = selectChange.selectedIndex;

    console.log(this.optionData[index]);
    this.selectedObject = this.optionData[index];
    let valueExpr = this.selectedObject[this.valueExpr];
    let displayExpr = this.selectedObject[this.displayExpr];

    let event = {
      name: 'selectChange',
      selectedElement: this.selectedObject,
      dataField: this.fileDataInput.dataField,
      value: valueExpr,
      component: this,
      displayValue: displayExpr,
      element: this.inputSelect.nativeElement

    }

    this.selectedEvent.emit(event)
  }

  selectChangeDxMx(ev, lista) {
    /*    console.log(ev.addedItems[0])
        console.log(this.lista)
        if(this.lista.tipoSelect=='single' && ev.addedItems.length>0){
          this.selectedObject[0]=ev.addedItems[0][this.lista.valueExpr];      
          lista.selectedItems=ev.addedItems;
        }else  
      */
    //console.log("ECCOLOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO ",ev)
    let that = this;
    this.selectedObject = lista.selectedItems.map(elem => { return elem[this.lista.valueExpr] });
    this.dataInput[this.fileDataInput.dataField] = this.selectedObject
    //this.fileDataInput.lista.related
    let related = this.lista.related;
    let ciccio = { ...ev.addedItems }
    let currentElement = Object.assign({}, ev.addedItems, ev.removedItems);
    currentElement.add = ev.addedItems;
    if (typeof related != 'undefined') {

      related.forEach((value, key) => {
        let arrayValue = value.split('|')
        if (arrayValue.length > 1) {
          that.dataInput[arrayValue[1]] = currentElement[arrayValue[0]];
        } else {
          that.dataInput[value] = that.selectedObject;
        }

      })
    }




    //-----------------------------------------------
    let event = {
      name: 'selectChange',
      selectedElement: this.selectedObject,
      dataField: this.fileDataInput.dataField,
      value: this.selectedObject,
      element: ev.element,
      addedItems: ev.addedItems,
      removedItems: ev.removedItems,
      currentElement: currentElement
    }
    this.selectedEvent.emit(event);
    //console.log(JSON.stringify(this.selectedObject));

  }

  selectChangeDx(ev) {
    if (!ev.selectedItem) {
      this.selectedObject = ev.selectedItem;
      let related = this.lista.related;
      if (typeof related != 'undefined') {

        related.forEach((value, key) => {
          let arrayValue = value.split('|')
          if (arrayValue.length > 1) {
            this.dataInput[arrayValue[1]] = null;
          } else {
            this.dataInput[value] = null;
          }

        })
      }

      let event = {
        name: 'selectChange',
        selectedElement: null,
        dataField: this.fileDataInput.dataField,
        value: null,
        displayVlaue: null,
        element: ev.element
      }

      this.selectedEvent.emit(event);
      return
    }

    this.selectedObject = ev.selectedItem;
    let valueExpr = this.selectedObject[this.valueExpr];
    let displayExpr = this.selectedObject[this.displayExpr];

    if (valueExpr) {
      let c = this.formGroup.get(this.fileDataInput.dataField)
      c.setValue(valueExpr)
      //console.log(c)
    }

    this.setDataRelated()

    let event = {
      name: 'selectChange',
      selectedElement: this.selectedObject,
      dataField: this.fileDataInput.dataField,
      value: valueExpr,
      displayVlaue: displayExpr,
      element: ev.element
    }

    this.selectedEvent.emit(event);

  }

  setDataRelated() {
    if (this.lista.related) {

      let selectedItem = this.selectedObject;

      let related = this.lista.related

      if (selectedItem != null) {
        related.forEach((value, key) => {
          let arrayValue = value.split('|')
          if (arrayValue.length > 1) {
            if (!selectedItem[arrayValue[0]]) {
              return
            }
            this.dataInput[arrayValue[1]] = selectedItem[arrayValue[0]];

          } else {
            if (!selectedItem[arrayValue[0]]) {
              return
            }
            this.dataInput[value] = selectedItem[value];

          }



        })
      }
    }
  }

  selectFocused(ev) {
    this.selectedFocused.emit(ev)
  }

  selFocusOut(ev) {
    this.selectedFocusOut.emit(ev)
  }

  onInitializzedSelectDX(event) {

    event.nativeElement = event.element;
    event.dxComponent = event.component;
    event.editorComponent = this;
    event.id = this.fileDataInput.dataField
    if (event.editorComponent && event.editorComponent.dataSelect !== undefined) {
      event.value = event.editorComponent.dataSelect
    }
    this.selectedEventInitialized.emit(event);

  }

  filterOptions(): void {
    this.filteredOptions = this.searchText ? this.optionData.filter(option =>
      option.display.toLowerCase().includes(this.searchText.toLowerCase())
    ) : this.optionData

  }

  toggleSelection(value: string, event: MouseEvent): void {
    event.preventDefault(); // Prevent the default behavior of the select element
    if (this.selectedObject.has(value)) {
      this.selectedObject.delete(value);
    } else {
      this.selectedObject.add(value);
    }
    // this.cdr.markForCheck(); // Ensure the change detection cycle is run
  }

  public focusElement() {
    if (this.isDX) {
      this.dxSelectBox.instance.focus()
    }
  }
}
